import { render, staticRenderFns } from "./Activites.vue?vue&type=template&id=56b968ce&lang=html"
import script from "./Activites.vue?vue&type=script&lang=js"
export * from "./Activites.vue?vue&type=script&lang=js"
import style0 from "./Activites.vue?vue&type=style&index=0&id=56b968ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports